import { updateItems } from '@/mocks/homeData';

const typeColorMap: Record<string, string> = {
  '新片入库': 'bg-accent-100 text-accent-700',
  '剧集更新': 'bg-primary-100 text-primary-700',
  '系统公告': 'bg-secondary-100 text-secondary-700',
  '专题策划': 'bg-accent-100 text-accent-700',
  '独家内容': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          网站更新 · 内容上线 · 系统公告实时同步
        </p>

        <div className="mt-10 relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>
          <div className="space-y-4">
            {updateItems.map((item) => (
              <a
                key={item.id}
                href="#updates"
                className="group cursor-pointer flex gap-5 relative"
              >
                <div className="hidden sm:flex flex-shrink-0 w-10 h-10 rounded-full bg-background-100 border-2 border-background-200 items-center justify-center z-10 transition-colors group-hover:border-primary-300">
                  <div className="w-2 h-2 rounded-full bg-primary-400"></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200/70 rounded-xl p-4 transition-all group-hover:border-primary-200">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-md text-[11px] font-semibold whitespace-nowrap ${typeColorMap[item.type] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.type}
                    </span>
                  </div>
                  <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}